import { Navigate, Outlet } from 'react-router-dom';
import { AccessRights } from 'common/account/AccessRights';
import { LoginPage } from 'client/pages/auth/LoginPage';
import { useUser } from './User';

export const AdminOutlet = () => {
  const { isLoggedIn, hasAccessRight } = useUser();
  if (!isLoggedIn) return <LoginPage />;
  if (!hasAccessRight(AccessRights.ADMIN_PAGES)) return <Navigate to="/" replace />;
  return <Outlet />;
};
